module.exports = __webpack_public_path__ + "img/switch.4625e783.svg";